import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  inventoryCard: {
    display: 'flex',
    width: 284,
    height: 'auto',
    flexDirection: 'column',
    alignItems: 'center',
    padding: 0
  },
  imageContainer: {
    height: 272,
    width: '100%',
    overflow: 'hidden',
    cursor: 'pointer'
  },
  image: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  title: {
    marginBottom: theme.spacing(2)
  },
  content: {
    width: '100%',
    padding: theme.spacing(4)
  },
  lastRow: {
    paddingBottom: 0
  },
  rowLabel: {
    color: theme.colorPalette.green_75,
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: '12px',
    textTransform: 'uppercase',
    fontFamily: theme.typography.fontFamily
  },
  rowText: {
    color: theme.colorPalette.green_80,
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  missingText: {
    fontStyle: 'italic'
  },
  actionIconContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: 'auto 0',
    height: '100%',
    padding: 0,
    cursor: 'pointer'
  },
  actionIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 24,
    width: 24
  },
  tooltip: {
    backgroundColor: theme.colors.tooltip_background
  }
}));

export default useStyles;
